<template>
  <div>
    <!--头部-->
    <div>
      <div v-if="showMask" class="mask"></div>
      <el-container class="index-con" style="margin: 0px; padding: 0px">
        <el-header class="index-header">
          <div style="margin-left: 17px; margin-top: 3px">
            万宏智慧停车场管理系统
          </div>
          <div>
            <div style="margin-left: 15px; float: left">
              <h3 style="font-size: 0.2rem">
                <img
                  @mouseenter="menuShow()"
                  style="
                    float: left;
                    width: 28px;
                    margin-top: 10px;
                    margin-right: -10px;
                  "
                  src="../../src/assets/img/icon2.png"
                  alt=""
                />
              </h3>
            </div>
            <nav class="navigation" @mouseleave="menuNone()">
              <ul>
                <li>
                  <span
                    :class="
                      indexvalue == -1
                        ? 'click-menu-span-active'
                        : 'click-menu-span'
                    "
                    @click="toIndex()"
                  >首页</span
                  >
                </li>
                <li>
                  <span
                    v-for="(item, index) in choosemenu"
                    :key="index"
                    :class="
                      indexvalue == index
                        ? 'click-menu-span-active'
                        : 'click-menu-span'
                    "
                    @click="toPath2(item, index)"
                  >{{ item.menuname }}
                    <img
                      @click.stop="delMenu(index, item)"
                      style="float: right; width: 20px; margin-top: 5px"
                      src="../../src/assets/img/icon3.png"
                      alt=""
                    />
                  </span>
                </li>
              </ul>
            </nav>
            <div class="head-right" style="float: right">
              <img src="../assets/img/jisoo3.jpg" alt="" />
              <span style="font-size: 15.5px; margin-left: 5px">{{
                  name
                }}</span>
              <!-- 下拉框 -->
              <span style="font-size: 15.5px; margin-left: 5px" @click="exit()"
              >退出</span
              >
            </div>
            <!-- 左侧菜单 -->
            <div
              class="menu"
              :class="showFlag ? 'showLeft' : ''"
              v-if="menu"
              @mouseleave="menuNone()"
            >
              <div class="head-nav">
                <div
                  v-for="menu in allmenu"
                  :key="menu.menuid"
                  :index="menu.menuname"
                >
                  <p class="head-title">{{ menu.menuname }}</p>
                  <ul>
                    <li
                      v-for="c in menu.menus"
                      :key="c.menuid"
                      :index="c.menuname"
                      :id="menu.menuid == activeindex ? 'choose' : ''"
                      @click="toPath(c)"
                      ref="selectFiles01"
                    >
                      <span >{{ c.menuname }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </el-header>
        <el-container class="index-con" style="height: calc(100vh - 100px)">
          <el-aside :class="showclass" v-if="showleftnav">
            <leftnav></leftnav>
          </el-aside>
          <el-container class="main-con">
            <el-main clss="index-main" style="padding: 0px">
              <router-view
                @pass-value="receiveValue"
                @select-id="selectValue"
                @menuss="menuss"
              ></router-view>
            </el-main>
          </el-container>
        </el-container>
      </el-container>
    </div>
  </div>
</template>
<script>
import leftnav from "../components/LeftNav.vue";
import {getPath} from "@/utils/ruoyi";
// 导入组件

export default {
  name: "navcon",
  data() {
    return {
      collapsed: true,
      // tile: "",
      imgshow: require("../assets/img/show.png"),
      imgsq: require("../assets/img/sq.png"),
      user: {},
      collapsed: false,
      activeindex: 0,
      menu: false,
      showMask: false,
      showFlag: false,
      choosemenu: [],
      indexvalue: -1,
      showclass: "asideshow",
      // noleftnav: false,
      valueFromParent: "",
    };
  },
  // 注册组件
  components: {
    leftnav,
  },
  created() {
    this.name = localStorage.getItem("name");

    // 监听
    this.$root.Bus.$on("toggle", (value) => {
      if (value) {
        this.showclass = "aside";
      } else {
        this.showclass = "asideshow";
      }
    });
  },
  computed: {
    name() {
      return this.$store.state.user.nickname
    },
    showleftnav() {
      const sidebarRouters = this.$store.state.permission.sidebarRouters;
      if (sidebarRouters && sidebarRouters.length) {
        return true;
      } else {
        return false;
      }
    },
    // 所有的路由信息
    allmenu() {
      return this.$store.state.permission.mainModuleRouters;
    },
  },
  mounted() {
    this.address();
  },
  methods: {
    //子传父
    menuss(value) {
      this.toPath(value);
    },
    receiveValue(value) {
      // this.noleftnav = value;
    },
    selectValue(value) {
      this.valueFromParent = value;
    },
    toIndex() {
      this.indexvalue = -1;
      this.$router.push({ path: "/index" });
      // this.$store.commit('SET_MAIN_MENU_MODULE_ACTIVE_URL', '')
      // this.$store.commit('SET_SIDEBAR_ROUTERS', []);
    },
    menuShow() {
      this.menu = true;
      this.showMask = true;
      this.showFlag = this.showFlag ? false : true;
    },
    menuNone() {
      this.menu = false;
      this.showMask = false;
    },
    // 退出登录
    exit() {
      this.$confirm("退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch('LogOut').then(() => {
            location.href = getPath('/index');
          })
          // setTimeout(() => {
          //   this.$store.commit("logout", "false");
          //   this.$router.push({ path: "/login" });
          //   this.$message({
          //     type: "success",
          //     message: "已退出登录!",
          //   });
          // }, 1000);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    address() {
      var mm = window.location.href;
      let index = mm.indexOf("#/");
      let result = mm.substring(index + 1, mm.length);
      this.$root.Bus.$on("toggle", (value) => {
        this.collapsed = !value;
      });
      var menu = this.allmenu;
      for (var idx in menu) {
        var data = menu[idx].url;
        console.log("data11", data);
        if (result == data) {
          this.activeindex = idx;
        }
      }
    },
    delMenu(index) {
      this.choosemenu.splice(index, 1);
      let nextMenu;
      if (this.indexvalue == 0 && this.choosemenu.length == 0) {
        nextMenu = {};
        this.indexvalue = -1;
        this.$router.push("/index");
      } else if (index == this.choosemenu.length) {
        nextMenu = this.choosemenu[index - 1];
        this.$router.push(this.choosemenu[index - 1].url);
        this.indexvalue = index - 1;
      } else {
        nextMenu = this.choosemenu[index];
        this.$router.push(this.choosemenu[index].url);
        this.indexvalue = index;
      }
      //修改侧边栏菜单
      // this.$store.commit('SET_MAIN_MENU_MODULE_ACTIVE_URL', nextMenu.url)
      // if (nextMenu !== {}) {
      //   const menuArray = this.$store.state.permission.sidebarRoutersMap[nextMenu.componentName];
      //   this.$store.commit('SET_SIDEBAR_ROUTERS', menuArray);
      // } else {
      //   this.$store.commit('SET_SIDEBAR_ROUTERS', []);
      // }
    },
    toPath(menu) {
      var hh = false;
      if (this.choosemenu.length == 0) {
        hh = false;
      } else if (this.choosemenu.length > 0) {
        for (var j = 0; j < this.choosemenu.length; j++) {
          if (this.choosemenu[j].menuname == menu.menuname) {
            this.indexvalue = j;
            this.doToPath(menu);
            this.menu = false;
            this.showMask = false;
            hh = true;
          }
        }
      }
      if (hh == false) {
        this.choosemenu.push(menu);
        this.menu = false;
        this.indexvalue = this.choosemenu.length - 1;
        console.log(this.indexvalue);
        this.showMask = false;
        this.doToPath(menu);
        var menuname = menu.menuname;
        for (var idx in this.$refs.selectFiles01) {
          var data = this.$refs.selectFiles01[idx].innerText;
          if (menuname == data) {
            this.activeindex = idx;
          }
        }
      }
    },
    doToPath(menu) {
      this.$router.push(menu.url);
      // const menuArray = this.$store.state.permission.sidebarRoutersMap[menu.componentName];
      // this.$store.commit('SET_MAIN_MENU_MODULE_ACTIVE_URL', menu.url)
      // this.$store.commit('SET_SIDEBAR_ROUTERS', menuArray)
    },
    toPath2(menu, index) {
      this.indexvalue = index;
      this.doToPath(menu);
    },
  },
};
</script>
<style>
.el-date-editor .el-range-separator {
  margin-top: -8px;
}
::-webkit-scrollbar {
  width: 8px;
  margin-left: 5px;
}

::-webkit-scrollbar-thumb {
  background-color: #bbbbbb;
  border-radius: 10px;
}
.mask {
  position: fixed;
  top: 98px;
  left: 390px;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.search-top >>> .el-date-editor .el-range-input {
  margin-top: 5px;
}
.search-top >>> .el-input__icon {
  margin-top: -3px;
  font-size: 15px;
}
.pm {
  height: 100vh;
  /* background: white; */
}
.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.el-aside {
  background: white !important;
  transition: width 0.5s;
  -webkit-transition: width 0.5s;
  -moz-transition: width 0.5s;
  -webkit-transition: width 0.5s;
  -o-transition: width 0.5s;
}

.aside {
  width: 64px !important;
  height: 100%;
  background-color: #ffffff;
  margin: 0px;
}
.asideshow {
  width: 200px !important;
  height: 100%;
  background-color: #ffffff;
  margin: 0px;
}
.index-header {
  background-color: #0099ff;
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  border-bottom: none;
  padding-left: 0px;
  padding-right: 0px;
  height: 98px !important;
  line-height: 45px;
}
.index-main {
  padding: 0px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  background: #0099ff;

  display: flex;
  overflow: hidden;
}
.showLeft {
  transform: translate3d(0, 0, 0);
}
.submenu {
  position: absolute;
  top: 6px;
  right: 2px;
}

.confirm-p {
  /* word-break: break-all; */
  width: 80%;
}
.el-message-box {
  width: 80%;
}

/* 头部 */
body {
  background: #f3f3f3;
}
* {
  padding: 0px;
  margin: 0px;
}
.heared {
  width: 100%;
  background-color: #0099ff;
  color: #ffffff;
  line-height: 45px;
  padding-top: 4px;
}
.heared h3 {
  float: left;
}
.navigation {
  width: 95%;
  white-space: nowrap;
  overflow: hidden;
  margin-left: 3%;
  text-overflow: ellipsis;
  direction: rtl; /* 设置文本方向从右到左 */
  text-align: left;
}

.navigation ul {
  display: inline-block;
  padding: 0;
  margin: 0;

  list-style-type: none;
  direction: ltr; /* 重新设置文本方向为左到右 */
}

.navigation li {
  display: inline;
}

.navigation a {
  text-decoration: none;
  padding: 5px 10px;
}
.head-title {
  color: #0099ff;
  font-size: 14.5px;
}
.menu {
  background: rgb(255, 255, 255);
  height: 89.8vh;
  /* box-sizing: border-box; */
  position: absolute;
  left: 0px;
  top: 98px;
  width: 390px;
  z-index: 20;
  /* opacity: 0;

  animation: showDiv 0.5s forwards; */
}
@keyframes showDiv {
  from {
    transform: translateX(-100%);
  }

  to {
    transform: translateX(0);

    opacity: 1;
  }
}
.click-menu-span {
  width: 100px;
  height: 30px;
  line-height: 30px;
  padding: 0px 10px;
  background: #67aaf7;
  display: inline-block;
  font-size: 15px;
  margin-right: 5px;
  /* border: 1px solid #fcfcfc; */
}
.click-menu-span-active {
  width: 100px;
  height: 30px;
  line-height: 30px;
  padding: 0px 10px;
  display: inline-block;
  font-size: 15px;
  margin-right: 5px;
  background: #8ccaf3;
}
.head-nav {
  display: inline-block;
  margin-left: 6%;
  width: 100%;
}
.head-nav ul li {
  display: inline-block;
  width: 28%;
  font-size: 14px;
  text-align: center;
  background: #eeeeee;
  list-style-type: none;
  line-height: 40px;
  margin-right: 10px;
  margin-bottom: 5px;
  color: rgb(94, 94, 94);
}
/* .head-nav ul li:hover {
  display: inline-block;
  width: 6%;
  font-size: 14px;
  text-align: center;
  list-style-type: none;
  border-bottom: 4px solid rgb(255, 255, 255);
} */
/* #choose {
  border-bottom: 4px solid white;
} */
.head-right {
  width: 160px;
  position: absolute;
  float: right;
  right: 0px;
  top: 0px;
}
.head-right img {
  width: 40px;
  height: 40px;
  float: left;
  margin-top: 5px;
  margin-right: 5px;
  border-radius: 50px;
}

.title {
  width: 97%;
  padding: 10px;
  border-radius: 5px;
  margin: 10px auto;
  background: #ffffff;
  font-size: 14px;
}
.el-message-box {
  width: 30%;
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue